export default __webpack_public_path__ + "static/media/YT.75139e73.svg";